import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { CompareDetail } from '@src/pages/Compare';

export const Route = createLazyFileRoute('/compare/splunk')({
  component: SplunkComparePage,
});

function SplunkComparePage() {
  return (
    <DefaultLayout>
      <CompareDetail competitorId="splunk" />
    </DefaultLayout>
  );
}
